import { render, staticRenderFns } from "./Mandelbrot.vue?vue&type=template&id=43714f15&"
import script from "./Mandelbrot.ts?vue&type=script&lang=ts&"
export * from "./Mandelbrot.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports